<script setup lang="ts">
import EnvironmentFavicon from "./components/EnvironmentFavicon.vue";
import PageHeader from "@/components/layouts/PageHeader.vue";

import { onMounted, onUnmounted, provide, ref } from "vue";

import { app } from "./main";
import { AuthServiceSymbol } from "./services/injection";
import BackToTop from "./components/BackToTop.vue";
import useVuelidate from "@vuelidate/core";
import { PROVIDE_INJECT_SYMBOLS } from "./constants";
import { newGuid } from "./utils/uuidUtils";
const v$ = useVuelidate();
const authService = app.config.globalProperties.$authService;
const pageContentContainerId = ref<string>("");

onMounted(async () => {
  window.addEventListener("beforeunload", confirmExit);
  pageContentContainerId.value = `${newGuid()}_page_content_container_id`;
});

// Remove event listener when component is unmounted
onUnmounted(() => {
  window.removeEventListener("beforeunload", confirmExit);
});

function confirmExit(event: any) {
  if (v$.value.$anyDirty) {
    event.preventDefault();
    event.returnValue = "";
  }
}

// global error
provide(PROVIDE_INJECT_SYMBOLS.PAGE_CONTENT_CONTAINER_ID, pageContentContainerId);

provide(AuthServiceSymbol, authService);
</script>

<template>
  <PageHeader />
  <div :id="pageContentContainerId" class="container page-container" style="min-height: 100vh">
    <div class="content">
      <RouterView v-slot="{ Component }">
        <template v-if="Component">
          <KeepAlive
            :include="[
              'FinanslovsstrukturView',
              'RegnskabsstrukturView',
              'KontoplanView',
              'LoengrupperView',
            ]"
          >
            <component :is="Component"></component>
          </KeepAlive>
        </template>
      </RouterView>
    </div>
  </div>
  <BackToTop />
  <EnvironmentFavicon />
</template>
